import { makeRequest } from '../makeRequest';

export const getCountries = () => makeRequest('GET', `/countries`);

export default {};
